import $ from 'jquery';

import Cookie from "../../utils/Cookie";
var COOKIE_PROFILE= "profilTiers";


function waitUntil(isready, success, error, count, interval){
    if (count 	 === undefined)      count = 300;
    if (interval === undefined)      interval = 20;
    if (isready()) {
        success();
        return;
    }
    // The call back isn't ready. We need to wait for it
    setTimeout(function(){
		// We have run out of retries
        if (!count) { 
            if (error !== undefined) 
                error();
        } 
        // Try again    
		else 
            waitUntil(isready, success, error, count -1, interval);
    }, interval);
}


// Same as checkProfil() in search.js
// Returns if profil is ok
function checkProfil() {
	
	// return ok if no profils desactivated
	var profilsToDeactivate = window.cmsGlobals.chatbotConfig.profilToDeactivate;
	if ( profilsToDeactivate && profilsToDeactivate != "") {} else return true;
	
	// return ok if not connected (no profile)
	var profilT = Cookie.getByName(COOKIE_PROFILE);
	if (profilT === "") return true;
	
	// Profile desactived ?
	var listOfProfiles = profilsToDeactivate.split(',');
	var profileOk = true;
	listOfProfiles.forEach(function(profilToDeactivate){
		if (profilT.includes(profilToDeactivate)) 
			profileOk = false;
	});
	return profileOk;
}


const initInteract = function () {
	
 	// Check condition interact checkbox :
    // Cancel if deactivated
    if (document.getElementById('sticky_hideContact'))
        return;

	// Vars
    var pageType = "DEFAULT",
        pageParcours = "DEFAULT",
        pageCategory = "";
    if (window.cmsAPI.breakpoint.getCurrentContext() === 'mobile') {
        // manage Interact / contextual menu
        waitUntil(
			// isready ?
            function () { return $('#interact-fab').length > 0; },
			// success
            function () { window.cmsAPI.fab.register({name: "contextual", domId: "contextual-fab"}); },
			// error (do nothing)
            function () { },
			// retrial count and timeout
			300, 20); 
    }
	/* // 3264 commented out :
    if (document.getElementById('sticky_pageType'))
        pageType = document.getElementById('sticky_pageType').getAttribute('data-value');
    if (document.getElementById('sticky_pageParcours'))
        pageParcours = document.getElementById('sticky_pageParcours').getAttribute('data-value');
    if (document.getElementById('sticky_pageCategorie'))
        pageCategory = document.getElementById('sticky_pageCategorie').getAttribute('data-value');
	
    //  Set detfault pageType when global chatbox activated
    if ((window.cmsGlobals.interactConfig.activateGlobalChatbot)
        && (pageType === "")
        && (pageParcours === "")) {
        pageType = "DEFAULT";
    }*/
		
	// Init
    if ((typeof window.sdcInteract !== "undefined") && (typeof window.sdcInteract.api !== "undefined")) {
        window.sdcInteract.api.init({parcours:pageParcours, categorie:pageCategory, pageType:pageType});
    }

	// Handle clicks (when document loaded)
    $(document).on('click','.interactAction',function(event){
        event.stopPropagation();
        var currentInteractAction = $(this).data('cms-param');
        if (typeof window.sdcInteract !== 'undefined') {
            window.sdcInteract.api.openFeatureStickyPanel({feature: currentInteractAction });
        }
    });
	

	// ** SOBOT ***
	
	// Check conditions :
	// - Globally disabled ?
	if (window.cmsGlobals.chatbotConfig.disabled) return true;
	// - Interact api loaded ?
	if ((typeof sdcInteract == "undefined") || (typeof  sdcInteract.api == "undefined")) return true;
	// - Chatbot checkbox activated ?
	if (document.getElementById('chatbot_activated')==null) return true;
	
	// Check profil
	if (!checkProfil()) return true; //was _self. in sobot.js
		
	// Load Sobot Api
	$.getScript("/icd/static/pch-front/public/pch-lanceur.js", function(data, textStatus, jqxhr){ var result = jqxhr.status; }); 
	// -> charge : /icd/static/pch-front-js/3.0.11-V3-RC3/awtPchBuilder.js

};

export {initInteract};


// WEBPACK FOOTER //
// ./src/js/cms/commons/interact.js